import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { TextInput } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { ErrorMessage } from 'shared/domains/forms/components/ErrorMessage';
export function EmailField() {
    const { isSubmitting } = useFormikContext();
    const [field, meta] = useField('email');
    const error = Boolean(meta.touched && meta.error);
    return (<Fragment>
      <TextInput {...field} stretch invalid={error} disabled={isSubmitting} label={t({ comment: 'Edit eSigning party email dialog - email input label', message: 'Email' })} placeholder={t({ comment: 'Edit eSigning party email dialog - email input placeholder', message: 'Email...' })}/>
      <ErrorMessage name="email"/>
    </Fragment>);
}
